import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('zs_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve stored image paths (uploads are relative /api/media/...) to absolute URLs
export const resolveImg = (url) => {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  return `${BACKEND}${url}`;
};

// ---- Public ----
export const createEnquiry = (payload) => client.post('/enquiries', payload).then(r => r.data);
export const paymentsConfig = () => client.get('/payments/config').then(r => r.data);
export const createFranchisePayment = (enquiry_id) => client.post('/payments/franchise/order', { enquiry_id }).then(r => r.data);
export const verifyFranchisePayment = (body) => client.post('/payments/franchise/verify', body).then(r => r.data);
export const createOrder = (payload) => client.post('/orders', payload).then(r => r.data);
export const getMenu = () => client.get('/content/menu').then(r => r.data);
export const getCategories = () => client.get('/content/categories').then(r => r.data);
export const getGallery = () => client.get('/content/gallery').then(r => r.data);
export const getReels = () => client.get('/content/reels').then(r => r.data);
export const getCareers = () => client.get('/content/careers').then(r => r.data);

// ---- Job applications ----
export const submitApplication = (formData) => client.post('/applications', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
export const listApplications = () => client.get('/admin/applications').then(r => r.data);
export const updateApplicationStatus = (id, status) => client.patch(`/admin/applications/${id}`, { status }).then(r => r.data);
export const deleteApplication = (id) => client.delete(`/admin/applications/${id}`).then(r => r.data);

// ---- Auth ----
export const authSession = (session_id) => client.post('/auth/session', { session_id }).then(r => r.data);
export const authLogin = (username, password) => client.post('/auth/login', { username, password }).then(r => r.data);
export const authMe = () => client.get('/auth/me').then(r => r.data);
export const authLogout = () => client.post('/auth/logout').then(r => r.data);
export const changePassword = (current_password, new_password) => client.post('/auth/change-password', { current_password, new_password }).then(r => r.data);

// ---- Customer account ----
export const getMyOrders = () => client.get('/me/orders').then(r => r.data);
export const getMyCart = () => client.get('/me/cart').then(r => r.data);
export const saveMyCart = (items) => client.put('/me/cart', { items }).then(r => r.data);
export const updateProfile = (body) => client.put('/me/profile', body).then(r => r.data);

// ---- Admin: enquiries & orders ----
export const adminEnquiries = () => client.get('/admin/enquiries').then(r => r.data);
export const setEnquiryStatus = (id, status) => client.patch(`/admin/enquiries/${id}`, { status }).then(r => r.data);
export const deleteEnquiry = (id) => client.delete(`/admin/enquiries/${id}`).then(r => r.data);
export const adminOrders = () => client.get('/admin/orders').then(r => r.data);
export const setOrderStatus = (id, status) => client.patch(`/admin/orders/${id}`, { status }).then(r => r.data);
export const deleteOrder = (id) => client.delete(`/admin/orders/${id}`).then(r => r.data);

// ---- Admin: content CRUD (name = menu|categories|gallery|reels) ----
export const createContent = (name, body) => client.post(`/admin/${name}`, body).then(r => r.data);
export const updateContent = (name, id, body) => client.put(`/admin/${name}/${id}`, body).then(r => r.data);
export const deleteContent = (name, id) => client.delete(`/admin/${name}/${id}`).then(r => r.data);

// ---- Admin: staff management (owner only) ----
export const listStaff = () => client.get('/admin/staff').then(r => r.data);
export const createStaff = (body) => client.post('/admin/staff', body).then(r => r.data);
export const resetStaffPassword = (id, new_password) => client.post(`/admin/staff/${id}/password`, { new_password }).then(r => r.data);
export const deleteStaff = (id) => client.delete(`/admin/staff/${id}`).then(r => r.data);

// ---- Admin: upload ----
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return client.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
};

export default client;
